export default __webpack_public_path__ + "static/media/heraldo-ruffino.b0068b55.webp";